import React from 'react';
import { FiImage, FiTrash2 } from 'react-icons/fi';
import { HeaderCell } from './ListTableColumn';
import arrowUpIcon from '../../../../assets/image/arrow_up.svg';
import arrowDownIcon from '../../../../assets/image/arrowD.svg';

export const getListDetailsTableColumns = (
	handleSort,
	sortDirection = {},
	handleRemoveProduct,
	expandedProductIds = [],
	handleToggleExpand,
	handleProductClick
) => [
	{
		field: 'PRODUCTNAME',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 240,
		flex: 1.5,
		headerComponent: () => (
			<HeaderCell field="PRODUCTNAME" label="PRODUCTNAME" handleSort={handleSort} sortDirection={sortDirection} />
		),
		cellRenderer: (params) => {
			const isBatch = params.data?.isBatch;
			if (isBatch) {
				return (
					<div className="d-flex align-items-center ps-4" data-testid={`batch-row-${params.data?.id}`}>
						<span className="fw-semibold text-dark">{params.value}</span>
					</div>
				);
			}

			const productId = params.data?.id;
			const isOpen = expandedProductIds.includes(productId);
			const batches = params.data?.batches;
			const hasNoBatches = Array.isArray(batches) && batches.length === 0;

			return (
				<div className="d-flex align-items-center gap-2" data-testid={`product-list-detail-row-${productId}`}>
					{!hasNoBatches ? (
						<img
							src={isOpen ? arrowUpIcon : arrowDownIcon}
							alt="toggle-accordion"
							className="cursor-pointer accordion-arrow-icon"
							onClick={(e) => handleToggleExpand && handleToggleExpand(productId, e)}
							data-testid={`accordion-toggle-btn-${productId}`}
						/>
					) : (
						<span className="accordion-arrow-placeholder" />
					)}
					<div className="list-thumb-icon d-flex align-items-center justify-content-center rounded ms-1">
						<FiImage />
					</div>
					<span
						className="fw-semibold text-dark cursor-pointer"
						data-testid={`product-name-link-${productId}`}
						onClick={(e) => {
							e.stopPropagation();
							if (handleProductClick) handleProductClick(productId);
						}}
					>
						{params.value}
					</span>
				</div>
			);
		},
	},
	{
		field: 'UPC',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1.2,
		headerComponent: () => <HeaderCell field="UPC" label="UPC" handleSort={handleSort} sortDirection={sortDirection} />,
		cellRenderer: (params) => <span className="text-dark">{params.value || '-'}</span>,
	},
	{
		field: 'CATEGORY',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 150,
		flex: 1,
		headerComponent: () => <HeaderCell field="CATEGORY" label="CATEGORY" handleSort={handleSort} sortDirection={sortDirection} />,
		cellRenderer: (params) => <span className="text-dark">{params.value || '-'}</span>,
	},
	{
		field: 'AVAILABLE STOCK',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 160,
		flex: 1,
		headerComponent: () => <HeaderCell field="AVAILABLE STOCK" label="AVAILABLE STOCK" handleSort={handleSort} sortDirection={sortDirection} />,
		cellRenderer: (params) => <span className="fw-semibold text-success">{params.value}</span>,
	},
	{
		field: 'UNIT PRICE',
		headerClass: 'HeaderBg right-align',
		cellClass: 'right-align',
		suppressSizeToFit: true,
		minWidth: 130,
		flex: 1,
		headerComponent: () => <HeaderCell field="UNIT PRICE" label="UNIT PRICE" handleSort={handleSort} sortDirection={sortDirection} isRight={true} />,
		cellRenderer: (params) => <span className="fw-semibold text-dark">{params.value}</span>,
	},
	{
		field: 'ACTIONS',
		headerName: 'ACTIONS',
		headerClass: 'HeaderBg text-center',
		cellClass: 'text-center',
		suppressSizeToFit: true,
		minWidth: 100,
		flex: 0.8,
		sortable: false,
		cellRenderer: (params) => {
			if (params.data?.isBatch) {
				return null;
			}
			return (
				<button
					type="button"
					className="btn p-1 text-danger border-0 bg-transparent"
					title="Remove Product from List"
					data-testid={`product-list-detail-remove-product-btn-${params.data?.id}`}
					onClick={() => handleRemoveProduct && handleRemoveProduct(params.data?.id)}
				>
					<FiTrash2 className="action-trash-icon" />
				</button>
			);
		},
	},
];

